import * as i0 from "@angular/core";
export class WarningboxStore {
}
WarningboxStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WarningboxStore_Factory() { return new WarningboxStore(); }, token: WarningboxStore, providedIn: "root" });
export var WarningboxStoreKeys;
(function (WarningboxStoreKeys) {
})(WarningboxStoreKeys || (WarningboxStoreKeys = {}));
